import React from 'react';

const VideoDetail = ({video}) => {
  if(!video) {
    return <div>Loading...</div>;
  }
  const videoId = video.id.videoId;
  const url = `https://www.youtube.com/embed/${videoId}`;
  return (
    <div className="video-detail col-md-8">
      <div className="embed-responsive embed-responsive-16by9">
        <iframe className="embed-responsive-item" src={url}></iframe>
      </div>
      <div className="details">
        <div style={{marginTop: "50px"}}><h1>{video.snippet.title}</h1></div> 
        <div>{video.snippet.description}</div>
      </div>
    </div>
  )
  
};

export default VideoDetail;


// WEBPACK FOOTER //
// ./src/components/VideoDetail.js